import React from 'react';

const ListIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries" data-testid="test-list-icon">
      <div className="vbz-icon-beneficiaries-list" />
    </div>
  );
};

export default ListIcon;
